module.exports = __webpack_public_path__ + "static/media/bootcamp.cd64ebeb.svg";